import { render } from "./UserUpdatePassword.vue?vue&type=template&id=576f1d82"
import script from "./UserUpdatePassword.vue?vue&type=script&lang=js"
export * from "./UserUpdatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__